import { useQuery } from "@tanstack/react-query"

import { useAuth } from "src/context/AuthContext"

/**
 * Fetches the public content library items for a media-first channel.
 * Calls GET /channel_media/{channelId} on the auth server — no authentication required.
 */
export function useUnauthChannelMedia(channelId: string | null) {
  const { authApi } = useAuth()

  return useQuery({
    queryKey: ["unauth", "channel_media", channelId],
    queryFn: async () => {
      const response = await authApi.getChannelMedia(channelId!)
      if (response.kind !== "ok") {
        throw new Error(`Failed to fetch channel media: ${response.kind}`)
      }
      return response.data
    },
    enabled: !!channelId,
    staleTime: 0, // always fetch fresh — channel content changes as admins add new items
    gcTime: 0, // don't persist; prevents stale empty cache from suppressing requests
    retry: 1,
  })
}
